// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"55570593","693":"9fba097f","741":"5277b37a","845":"a51f884a","983":"0401e521"}[chunkId] + ".chunk.js";
};